function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { useCallback } from 'react';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { useMixPanelTracking } from '../tracking/TrackingProvider';
import { useCommonTrackData } from './use-common-track-data';
export var useTrackingEvent = function() {
    var commonProperties = useCommonTrackData();
    var _useMixPanelTracking = useMixPanelTracking(), sendDatToMixPanel = _useMixPanelTracking.track;
    var sendDataToGTM = useGTMDispatch();
    var mixPanelTracking = useCallback(function(mixPanelProperties) {
        sendDatToMixPanel === null || sendDatToMixPanel === void 0 ? void 0 : sendDatToMixPanel({
            name: mixPanelProperties === null || mixPanelProperties === void 0 ? void 0 : mixPanelProperties.eventName,
            properties: _object_spread({}, mixPanelProperties)
        });
    }, [
        sendDatToMixPanel
    ]);
    var gtmTracking = useCallback(function(gtmProperties) {
        sendDataToGTM(_object_spread({
            event: gtmProperties === null || gtmProperties === void 0 ? void 0 : gtmProperties.eventName
        }, gtmProperties, commonProperties));
    }, [
        commonProperties,
        sendDataToGTM
    ]);
    var trackData = useCallback(// gtm and mixpanel tracking are defaulted to true
    function(_param) {
        var _param_isGTMTracking = _param.isGTMTracking, isGTMTracking = _param_isGTMTracking === void 0 ? true : _param_isGTMTracking, _param_isMixPanelTracking = _param.isMixPanelTracking, isMixPanelTracking = _param_isMixPanelTracking === void 0 ? true : _param_isMixPanelTracking, rest = _object_without_properties(_param, [
            "isGTMTracking",
            "isMixPanelTracking"
        ]);
        var isTrackingEnabled = rest.isTrackingEnabled, filteredRest = _object_without_properties(rest, [
            "isTrackingEnabled"
        ]);
        if (isTrackingEnabled) {
            if (isMixPanelTracking && !!filteredRest.eventName) {
                mixPanelTracking(filteredRest);
            }
            if (isGTMTracking) {
                gtmTracking(filteredRest);
            }
        }
    }, [
        mixPanelTracking,
        gtmTracking
    ]);
    return {
        trackData: trackData
    };
};
